import { useCallback, useMemo } from "react";
import { getAgendaNodesChildren, getAgendaNodesRoot } from "../../../../../app/src/services/agendaService";
import { useFilterNodes } from "../../Buscar/state/useFilterNodes";

const AGENDA_NODE_LOADERS = { loadRoot: getAgendaNodesRoot, loadChildrenOf: getAgendaNodesChildren };

/**
 * Nodos de filtro de la Agenda (type=agenda) sobre el mismo hook que el buscador.
 *
 * Contrato §18.2: "La primera opción por order («Todos los deportes») es el estado sin filtro: si
 * está marcada, no se envía nodes". Por eso `resolveIds` descarta ese nodo: una URL con
 * `?sport=todos-los-deportes` equivale a no filtrar.
 * Supuesto: "primera opción" = primer nodo raíz por `order` y sin hijos (un padre no se puede
 * seleccionar, solo despliega).
 *
 * @param {number|string} [interfazId]
 */
export const useAgendaFilterNodes = (interfazId) => {
  const nodes = useFilterNodes(interfazId, AGENDA_NODE_LOADERS);
  const { roots, resolveIds: resolveAllIds } = nodes;

  const allNodeId = useMemo(() => {
    const first = [...roots].sort((a, b) => a.order - b.order)[0];
    return first && !first.has_children ? first.id : null;
  }, [roots]);

  const resolveIds = useCallback((slugs) => resolveAllIds(slugs).filter((id) => id !== allNodeId), [resolveAllIds, allNodeId]);

  return { ...nodes, resolveIds, allNodeId };
};
